<template>
    <v-container>
      <v-layout row>
        <Header title="Služby" subtitle="Ponúkame:"/>
      </v-layout>
    </v-container>

</template>

<script>
  import Header from '@/components/widgets/Header'
  export default {
    name: 'Services',
    components: {
      Header
    }
  }
</script>

<style>
</style>